/* Baja Llama - Too Breezy landing page interactions.
   Colour swatches swap the hero product. The hero cycles that product's
   full Shopify image set, laydown first. Sold-out sizes are disabled,
   not hidden. */
(function () {
  var root = document.querySelector('.blbz');
  if (!root) { return; }
  var tag = document.getElementById('blbz-data');
  if (!tag) { return; }

  var COLORS;
  try { COLORS = JSON.parse(tag.textContent); } catch (e) { return; }
  if (!COLORS || !COLORS.length) { return; }

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/.00$/, '');
  };

  var slidesBox = root.querySelector('[data-blbz-slides]');
  var dotsBox   = root.querySelector('[data-blbz-dots]');
  var counter   = root.querySelector('[data-blbz-count]');
  var prevBtn   = root.querySelector('[data-blbz-prev]');
  var nextBtn   = root.querySelector('[data-blbz-next]');
  var elNow     = root.querySelector('[data-blbz-now]');
  var elWas     = root.querySelector('[data-blbz-was]');
  var elCname   = root.querySelector('[data-blbz-colorname]');
  var elSizes   = root.querySelector('[data-blbz-sizes]');
  var elAdd     = root.querySelector('[data-blbz-add]');
  var elHint    = root.querySelector('[data-blbz-hint]');
  var swatches  = Array.prototype.slice.call(root.querySelectorAll('[data-blbz-swatch]'));

  var current = 0;
  var shot = 0;
  var chosen = null;

  function addToCart(variantId, done) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true }));
        if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
          try { window.Rebuy.SmartCart.show(); } catch (e) {}
        }
        if (done) { done(true); }
      })
      .catch(function () { if (done) { done(false); } });
  }

  function paintShot(n) {
    if (!slidesBox) { return; }
    var imgs = slidesBox.children;
    if (!imgs.length) { return; }
    if (n < 0) { n = imgs.length - 1; }
    if (n >= imgs.length) { n = 0; }
    shot = n;
    for (var i = 0; i < imgs.length; i++) {
      if (i === n) { imgs[i].classList.add('is-on'); } else { imgs[i].classList.remove('is-on'); }
    }
    if (dotsBox) {
      var dots = dotsBox.children;
      for (var d = 0; d < dots.length; d++) {
        if (d === n) { dots[d].classList.add('is-on'); } else { dots[d].classList.remove('is-on'); }
      }
    }
    if (counter) { counter.textContent = (n + 1) + ' / ' + imgs.length; }
    var many = imgs.length > 1;
    if (prevBtn) { prevBtn.style.display = many ? 'flex' : 'none'; }
    if (nextBtn) { nextBtn.style.display = many ? 'flex' : 'none'; }
    if (counter) { counter.style.display = many ? 'block' : 'none'; }
    if (dotsBox) { dotsBox.style.display = many ? 'flex' : 'none'; }
  }

  function buildShots(c) {
    if (!slidesBox) { return; }
    slidesBox.innerHTML = '';
    if (dotsBox) { dotsBox.innerHTML = ''; }
    var list = (c.images && c.images.length) ? c.images : (c.image ? [c.image] : []);
    list.forEach(function (url, i) {
      var im = document.createElement('img');
      im.className = 'blbz__heroslide';
      im.src = url;
      im.alt = c.title + ' - view ' + (i + 1);
      im.loading = i === 0 ? 'eager' : 'lazy';
      slidesBox.appendChild(im);

      if (dotsBox) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'blbz__dot';
        d.setAttribute('aria-label', 'View image ' + (i + 1));
        d.addEventListener('click', function () { paintShot(i); });
        dotsBox.appendChild(d);
      }
    });
    paintShot(0);
  }

  function paintSizes() {
    if (!elSizes) { return; }
    var c = COLORS[current];
    elSizes.innerHTML = '';
    chosen = null;
    c.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'blbz__size';
      b.textContent = v.title;
      if (!v.available) {
        b.disabled = true;
        b.setAttribute('aria-label', v.title + ' sold out');
      } else {
        b.addEventListener('click', function () {
          Array.prototype.slice.call(elSizes.children).forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          chosen = v.id;
          if (elAdd) { elAdd.disabled = false; }
          if (elHint) { elHint.textContent = c.color + ' - size ' + v.title; }
        });
      }
      elSizes.appendChild(b);
    });
    if (elAdd) { elAdd.disabled = true; }
    if (elHint) { elHint.textContent = 'Pick a size to continue.'; }
  }

  function paintColor(i) {
    current = i;
    var c = COLORS[i];
    buildShots(c);
    if (elNow) { elNow.textContent = money(c.price); }
    if (elWas) {
      if (c.compare && c.compare > c.price) { elWas.textContent = money(c.compare); elWas.style.display = ''; }
      else { elWas.style.display = 'none'; }
    }
    if (elCname) { elCname.textContent = c.color; }
    swatches.forEach(function (s, n) {
      if (n === i) { s.classList.add('is-on'); } else { s.classList.remove('is-on'); }
    });
    paintSizes();
  }

  swatches.forEach(function (s, i) {
    s.addEventListener('click', function () { paintColor(i); });
  });

  if (prevBtn) { prevBtn.addEventListener('click', function () { paintShot(shot - 1); }); }
  if (nextBtn) { nextBtn.addEventListener('click', function () { paintShot(shot + 1); }); }

  if (elAdd) {
    elAdd.addEventListener('click', function () {
      if (!chosen) { return; }
      var label = elAdd.textContent;
      elAdd.disabled = true;
      elAdd.textContent = 'Adding...';
      addToCart(chosen, function (ok) {
        elAdd.textContent = ok ? 'Added to cart' : 'Try again';
        setTimeout(function () { elAdd.textContent = label; elAdd.disabled = false; }, 1800);
      });
    });
  }

  Array.prototype.slice.call(root.querySelectorAll('.blbz__ccard')).forEach(function (card) {
    var idx = parseInt(card.getAttribute('data-index'), 10);
    var quick = card.querySelector('[data-blbz-quick]');
    var box = card.querySelector('[data-blbz-qsizes]');
    if (!quick || !box || isNaN(idx)) { return; }
    var c = COLORS[idx];
    if (!c) { return; }

    c.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'blbz__qsize';
      b.textContent = v.title;
      if (!v.available) {
        b.disabled = true;
      } else {
        b.addEventListener('click', function () {
          b.textContent = '...';
          addToCart(v.id, function (ok) {
            if (ok) {
              var d = document.createElement('div');
              d.className = 'blbz__done';
              d.textContent = 'Added';
              box.parentNode.replaceChild(d, box);
              setTimeout(function () {
                if (d.parentNode) { d.parentNode.replaceChild(box, d); }
                card.classList.remove('is-picking');
                b.textContent = v.title;
              }, 1500);
            } else {
              b.textContent = v.title;
            }
          });
        });
      }
      box.appendChild(b);
    });

    quick.addEventListener('click', function () { card.classList.add('is-picking'); });
    card.addEventListener('mouseleave', function () { card.classList.remove('is-picking'); });
  });

  paintColor(0);
}());